import type { FC, SVGProps } from 'react'

export const Upload: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M9.42775 6.45831V8.40276C9.42775 8.66061 9.32532 8.9079 9.14299 9.09023C8.96066 9.27255 8.71337 9.37498 8.45552 9.37498H1.64996C1.39211 9.37498 1.14482 9.27255 0.962492 9.09023C0.780165 8.9079 0.677734 8.66061 0.677734 8.40276V6.45831"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.48319 3.05568L5.05263 0.625122L2.62207 3.05568"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.05273 0.625122V6.45846"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
